import { transformDateValue } from 'core/js/FormUtils';
export const getAudienceView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let audienceList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Email","fieldValue":transformDataValue(data.email,"emailid"), "fieldType":"emailid"},
              
              
            ],
            'dataList': [
                
              ]
          }

          audienceList.push(card);
  })
  return audienceList;
}